import React, { useEffect, useRef, useState } from "react";
import { PackageOptionsProps } from "../../types/data";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";

interface Props {
  options?: PackageOptionsProps[];
  packageId: string; // Make this required
}

const TourOptions: React.FC<Props> = ({ options, packageId }) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] =
    useState<PackageOptionsProps | null>(null);

  const gotoOptionDetail = (option: PackageOptionsProps) => {
    if (!packageId) {
      // Optionally show an error or just return
      console.error("Missing packageId for navigation");
      return;
    }
    if (option && option._id) {
      navigate(
        Paths.manageProductOptionsDetails
          .replace(":id", packageId)
          .replace(":optionId", option._id),
        {
          state: { option }, // pass full option data for convenience
        }
      );
    }
  };

  return (
    <div className="relative">
      {/* Option Cards */}
      <div className="flex overflow-x-auto space-x-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
        {options?.map((opt, idx) => (
          <div
            key={idx}
            className="flex-shrink-0 w-full max-w-[525px] p-2 sm:p-6 rounded-lg bg-white transition"
          >
            <h3 className="text-lg font-semibold mb-2">
              Title:{" "}
              <span className="font-normal">
                {opt?.title || `Option ${idx + 1}`}
              </span>
            </h3>
            <div className="space-y-2 text-sm">
              <p className="font-bold">Description</p>
              <p className="text-secondary line-clamp-2">
                {opt?.description || "No description provided."}
              </p>
            </div>
            <div className="space-y-2 mt-2 text-sm">
              <p className="font-bold">Reference Code</p>
              <p className="text-secondary capitalize">{opt?.referenceCode}</p>
            </div>
            <div className="space-y-2 mt-2 text-sm">
              <p className="font-bold">Cut Off Time</p>
              <p className="text-secondary capitalize">{opt?.cutOffTime}</p>
            </div>
            <div className="space-y-2 mt-2 text-sm">
              <p className="font-bold">Price</p>
              <p className="text-secondary">
                {opt?.pricingOption === "fixed" &&
                  `₦${opt?.pricePerIndividual?.[0]?.value ?? 0} per individual`}

                {opt?.pricingOption === "age_group" && (
                  <>
                    {(opt?.pricePerAgeGroup ?? []).map((group, i) => (
                      <span key={i}>
                        {group.ageGroup}: ₦{group.value}
                        {i < (opt.pricePerAgeGroup?.length ?? 0) - 1 && ", "}
                      </span>
                    ))}
                    <span> per age group</span>
                  </>
                )}

                {opt?.pricingOption === "vehicle" &&
                  `₦${opt?.pricePerVehicle?.[0]?.price ?? 0} per vehicle`}
              </p>
            </div>
            <button
              onClick={() => gotoOptionDetail(opt)}
              className="mt-4 text-blue-600 hover:underline text-sm"
            >
              View Details
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TourOptions;
